<script>
import DefaultTeaser from "./DefaultTeaser";
import Scholarship from "../content-types/Scholarship";

export default {
  extends: DefaultTeaser,
  mixins: [Scholarship],
};
</script>
